import React from "react";
import { FormControl, TextField, Autocomplete, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./order-select.scss";

interface OrderSelectProps {
  value: any;
  onChange: (value: { id: number | string; value: string; tenantId: number } | null) => void;
  options: { id: number | string; value: string, tenantId: number }[];
  disabled?: boolean;
  touched?: boolean;
  error?: any;
  isLabelled?: boolean;
  isRequired?: boolean;
  placeholder?: string;
}

const OrderSelect: React.FC<OrderSelectProps> = ({
  value,
  onChange,
  options,
  disabled,
  touched,
  error,
}) => {
  const selectedOrder =
  options.length > 0 && typeof value === "object" && value !== null
      ? options.find((order) => order.id === value.id) || null
      : typeof value === "number" ||
          (typeof value === "string" && value !== null)
        ? options.find((order) => order.id === value) || null
        : value;
  return (
    <FormControl
      fullWidth
      disabled={disabled}
      error={touched && !!error}
      className="order-select"
    >
      <Autocomplete
        id="order-select"
        options={options}
        getOptionLabel={(option) => option.value || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={selectedOrder}
        onChange={(_, newValue) => onChange(newValue || null)}
        disabled={disabled}
        popupIcon={<ExpandMoreIcon />}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select an order"
            error={touched && !!error}
            helperText={touched && error}
            InputLabelProps={{ shrink: false }}
          />
        )}
        sx={{
          "& .MuiOutlinedInput-root": {
            paddingRight: 0,
            paddingLeft: "9px",
            padding: 0,
          },
        }}
      />
    </FormControl>
  );
};

export default OrderSelect;
